<!--
 * @Date: 2021-04-29 08:01:49
 * @LastEditors: natsu
 * @LastEditTime: 2021-05-12 08:03:21
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/vue.png" /></div>
      <p>Vue-Router</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/vue-router/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "4.4.3",
          linkList: [
            ur + "4.4.3/vue-router.global.js",
            ur + "4.4.3/vue-router.global.min.js",
            ur + "4.4.3/vue-router.global.prod.js"]
        },
        {
          label: "4.2.5",
          linkList: [
            ur + "4.2.5/vue-router.global.js",
            ur + "4.2.5/vue-router.global.prod.js"]
        },
        {
          label: "3.6.5",
          linkList: [ur + "3.6.5/vue-router.js", ur + "3.6.5/vue-router.min.js"]
        },
        {
          label: "3.5.3",
          linkList: [ur + "3.5.3/vue-router.js", ur + "3.5.3/vue-router.min.js"]
        },
        {
          label: "3.5.1",
          linkList: [ur + "3.5.1/vue-router.js", ur + "3.5.1/vue-router.min.js"]
        },
        {
          label: "3.1.6",
          linkList: [ur + "3.1.6/vue-router.js", ur + "3.1.6/vue-router.min.js"]
        },
        {
          label: "3.1.3",
          linkList: [ur + "3.1.3/vue-router.js", ur + "3.1.3/vue-router.min.js"]
        },
        {
          label: "3.1.2",
          linkList: [ur + "3.1.2/vue-router.js", ur + "3.1.2/vue-router.min.js"]
        },
        {
          label: "3.1.1",
          linkList: [ur + "3.1.1/vue-router.js", ur + "3.1.1/vue-router.min.js"]
        },
        {
          label: "3.1.0",
          linkList: [ur + "3.1.0/vue-router.js", ur + "3.1.0/vue-router.min.js"]
        },
        {
          label: "3.0.1",
          linkList: [ur + "3.0.1/vue-router.js", ur + "3.0.1/vue-router.min.js"]
        },
        {
          label: "3.0.0",
          linkList: [ur + "3.0.0/vue-router.js", ur + "3.0.0/vue-router.min.js"]
        },
        {
          label: "2.8.1",
          linkList: [ur + "2.8.1/vue-router.js", ur + "2.8.1/vue-router.min.js"]
        },
        {
          label: "2.7.0",
          linkList: [ur + "2.7.0/vue-router.js", ur + "2.7.0/vue-router.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListVueRouter.vue